import * as LDClient from 'launchdarkly-js-client-sdk';

export function initializeLaunchDarkly(
    tenantId: string,
    provider: string,
    timeout = 5000
): Promise<LDClient.LDClient | undefined> {
    const hostname = window.location.hostname;

    let launchDarklyClientId = '6695466c3e8efc102093f3ee'; // Default: production

    if (hostname === 'localhost' || hostname.startsWith('localhost')) {
        launchDarklyClientId = '6695466c3e8efc102093f3ed'; // Test
    } else if (hostname.endsWith('stage.servicetitan.com')) {
        launchDarklyClientId = '669574e79324f1104d6cf800'; // Stage
    } else if (hostname.endsWith('st.dev')) {
        launchDarklyClientId = '6695750ae08568103d6fb20e'; // QA
    }

    const client = LDClient.initialize(launchDarklyClientId, {
        kind: 'multi',
        tenant: { key: tenantId },
        provider: { key: provider },
        tenantProvider: { key: `${tenantId}-${provider}` },
    });

    return new Promise((resolve) => {
        const timer = setTimeout(() => {
            console.error('LaunchDarkly initialization timed out');
            resolve(undefined);
        }, timeout);

        client.on('ready', () => {
            clearTimeout(timer);
            resolve(client);
        });

        client.on('failed', (err) => {
            clearTimeout(timer);
            console.error('LaunchDarkly initialization failed:', err);
            resolve(undefined);
        });
    });
}
